import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userParmas, MenuPath } from '@/facilities/model/user';
import {
  userLogin,
  getUserPermissions,
  getLoginUserInfo,
  getUserCurrentOrgan,
} from '@api';
import { ISLOGIN, THEME_ENUM, COLLAPS, ORGAN_TYPE } from '@/enums/pageEnum';

export interface AppState {
  theme: 'dark' | 'light' | string;
  language: string;
  role: string;
  userName: string;
  isLogin: boolean;
  userEmail?: string;
  roles: string[];
  collaps: boolean;
  menus?: MenuPath;
  organizationType?: string;
}

const initialState: AppState = {
  theme: localStorage.getItem(THEME_ENUM) || 'light',
  language: 'en',
  role: '',
  userName: '',
  userEmail: '',
  organizationType: localStorage.getItem(ORGAN_TYPE) || '',
  isLogin: localStorage.getItem(ISLOGIN) === 'true',
  roles: [],
  menus: undefined,
  collaps: localStorage.getItem(COLLAPS) === 'true',
};

export const fetchLogin = createAsyncThunk(
  'app/fetchLogin',
  async ({ params }: { params: userParmas }) => {
    const res = await userLogin(params);
    if (res.status !== 200) return false;
    // await thunkArg.dispatch(fetchUserInfo());
    return true;
  },
);

export const fetchUserInfo = createAsyncThunk(
  'app/fetchUserInfo',
  async (_, thunkArg) => {
    const org = await getUserCurrentOrgan();
    const { data } = await getLoginUserInfo();
    thunkArg.dispatch(setUser({ ...data.body, type: org.data.body.type }));
    return data.body;
  },
);

export const fetchGetOrgs = createAsyncThunk('app/fetchGetOrgs', async (_, thunkArg) => {
  try {
    const { data } = await getUserPermissions();
    return [...data.body, 'settings'];
  } catch (error: any) {
    localStorage.removeItem(ORGAN_TYPE);
    localStorage.removeItem(ISLOGIN);
    thunkArg.dispatch(setClearInfo());
    throw new Error(error);
  }
});

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMenus: (state, { payload }) => {
      state.menus = payload;
    },
    setLogin: (state, { payload }) => {
      state.isLogin = payload;
    },
    setRoles: (state, { payload }) => {
      state.roles = payload;
    },
    setCollaps: (state, { payload }) => {
      state.collaps = payload;
    },
    setThemeString: (state, { payload }) => {
      localStorage.setItem(THEME_ENUM, payload);
      state.theme = payload;
    },
    setClearInfo: (state) => {
      state.isLogin = false;
      state.role = '';
      state.userEmail = '';
      state.userName = '';
      state.organizationType = '';
      state.roles = [];
      state.menus = undefined;
    },
    setUser: (state, { payload }) => {
      const { role, nickname, email, type } = payload;
      state.isLogin = true;
      state.role = role;
      state.userEmail = email;
      state.userName = nickname;
      state.organizationType = type;
      localStorage.setItem(ORGAN_TYPE, type);
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(fetchLogin.fulfilled, (state, { payload }) => {
    //   if (!payload) return;
    //   state.isLogin = true;
    //   localStorage.setItem(ISLOGIN, "true");
    // });
    builder.addCase(fetchGetOrgs.fulfilled, (state, action) => {
      state.roles = action.payload;
      state.isLogin = true;
      localStorage.setItem(ISLOGIN, 'true');
    });
  },
});

export const {
  setThemeString,
  setMenus,
  setLogin,
  setRoles,
  setUser,
  setClearInfo,
  setCollaps,
} = appSlice.actions;
export default appSlice.reducer;
